import React, { useEffect, useContext } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";

// Components
import Home from "./components/Home/Home";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Newsletter from "./components/Footer/Newsletter/Newsletter";
import Bottom from "./components/Footer/Bottom/Bottom";
import Contact from "./components/Header/Contact/Contact";
import Service from "./components/Header/Service/Service";
import Student from "./components/Header/Students/Student";
import Load from "./components/Loader/Load";
import WebBatch from "./components/WebBatch/WebBatch";
import CodeMaster from "./components/CodeEditor/CodeMaster";
import CertiDetails from "./components/CertiVerification/CertiDetails/CertiDetails";
import Register from "./components/Register/Register";
import Report from "./components/Footer/GtuReport/Report";
import ViewReport from "./components/Footer/GtuReport/ViewReport";
import MyLoad from "./components/Loader/MyLoad";
import Success from "./Common/Success/Success";
import Search from "./components/Header/Search/Search";
import Left from "./components/LeftSideBar/Left";
import Right from "./components/Right/Right";
import SqlContent from "./components/Lerning/Sql/SqlContent/SqlContent";
import Terms from "./components/Footer/Tearm/Tearm";
import JoinForm from "./components/WebBatch/JoinForm/JoinForm";
import Confirm from "./components/WebBatch/JoinForm/Confirm/Confirm";
import NoPage from "./components/NoPage/NoPage";
import Tools from "./components/Footer/Tools/Tools";
import Fullstack from "./components/Header/Service/Course/Programs/Fullstack/Fullstack";
import Product from "./components/Header/Service/Course/Jason";

// Common & Admin
import GoToTop from "./components/GoToTop/GoToTop";
import Admin from "./Admin/Admin";
import OtherMail from "./Admin/OtherMail/OtherMail";
import OfferMail from "./Admin/OfferMail/OfferMail";
import Completion from "./Admin/Completion_letter/Completion";
import ScrollButton from "./Common/ScrollToTop/ScrollToTop";
import Model_Internship from "./Model_Internship/Model_Internship";
import Model_Learning from "./Model_Learning/Model_Learning";
import Choose from "./Common/Choose/Choose";

// Context Provider
import MyContextProvider from "./Uttis/MyContextProvider";
import MyContext from "./Uttis/MyContext";
import CandidateForm from "./Aptitude_test/CandidateForm/CandidateForm";


const AppContent = () => {
  const { modal, setModal, handleselect } = useContext(MyContext);

  useEffect(() => {
    const storedUser = localStorage.getItem("user_connected");
    if (!storedUser && !modal) {
      const timer = setTimeout(() => {
        handleselect(null);
        setModal(true);
      
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [modal, handleselect, setModal]);

  return (
    <>
      {/* SEO META TAGS */}
      <Helmet>
        <title>V-Ex Tech Solution - IT Internships & Training in Vadodara</title>
        <meta
          name="title"
          content="Top IT Courses and Internships in Vadodara - V-Ex Tech Solution"
        />
        <meta
          name="description"
          content="V-Ex Tech Solution offers IT training and internship programs in Vadodara. Learn Python, MERN Stack, Web Development, and Data Science with 100% practical learning from industry experts."
        />
        <meta
          name="keywords"
          content="IT internship Vadodara, IT training Vadodara, software development training, Python internship Vadodara, MERN stack training, V-Ex Tech Solution"
        />
        <meta name="author" content="V-Ex Tech Solution" />
      </Helmet>

      {/* Global Modals */}
      {/* <Choose /> */}
      <Load />
      <MyLoad />
      <Success />
      <Search />
      <OtherMail />
      <OfferMail />
      <Completion />
      <Left />
      <Right />
      <JoinForm />

      {/* Layout */}
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<Student />} />
        <Route path="/service" element={<Service Product={Product} />} />
        <Route path="/course/:coursename" element={<Fullstack Product={Product} />} />
        <Route path="/learning/:course/:title" element={<SqlContent />} />
        <Route path="/student-registration" element={<Register />} />
        <Route path="/certi-details" element={<CertiDetails />} />
        <Route path="/vxeditor" element={<CodeMaster />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/terms-condition" element={<Terms />} />
        <Route path="/admino" element={<Admin />} />
        <Route path="/confirm" element={<Confirm />} />
          <Route path="/aptitude-test" element={<CandidateForm />} />
        <Route path="/it-internship" element={<Model_Internship />} />
        <Route path="/it-training" element={<Model_Learning />} />
        <Route path="/course-batch/:batch" element={<WebBatch />} />
        <Route path="/internship-report" element={<Report />} />
        <Route path="/internship-report/:program" element={<ViewReport />} />
        <Route path="*" element={<NoPage />} />
       
      </Routes>

      {/* Footer Section */}
      <Newsletter />
      <Footer />
      <Bottom />

      {/* Floating & Utility Components */}
      <ScrollButton />
      <GoToTop />
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <MyContextProvider>
        <AppContent />
      </MyContextProvider>
    </BrowserRouter>
  );
};

export default App;
